import type { ComponentType } from 'react';
import { LogoPaperboi, type LogoPaperboiProps } from '@/components/logos';
import type { UiLogoVariant } from './UiLogo.types';

// One wordmark serves every slot today; the variant stays in the API because the
// `is-<variant>` class hook and the call sites already rely on it.
export const LOGO_COMPONENTS: Record<UiLogoVariant, ComponentType<LogoPaperboiProps>> = {
    emblem: LogoPaperboi,
    wordmark: LogoPaperboi,
    full: LogoPaperboi,
    footer: LogoPaperboi,
    menuBackground: LogoPaperboi,
};
